 import { Layout } from "antd";
import {AccountMenu} from './accountMenu';


const MainHeader = () => {

  const { Header } = Layout;

  return (
    <Header className="site-layout-background p-0 bg-gray-200/50 border-b flex border-gray-200" style={{borderBottomStyle: 'solid'}}>
        <div></div>
        <div className="flex-auto"></div>
        <div className="px-4">
            <AccountMenu />
        </div>
    </Header>
  );
};

export default MainHeader; 
